export default __webpack_public_path__ + "static/media/consol-1-ar.f3ce5ae0.svg";